export const RESTART_ON_REMOUNT = '@@saga-injector/restart-on-remount';
export const DAEMON = '@@saga-injector/daemon';
export const ONCE_TILL_UNMOUNT = '@@saga-injector/once-till-unmount';
export const API_ERROR_HANDLER_PAGE = '/error';
export const DEFAULT_REDUX_KEY = process.env.STORE_KEY || '__WTR_REDUX_STORE__';
